import { FC, useEffect, useState } from 'react';
import { Form, Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import V2FormTreeSelect from '@/common/components/Form/V2FormTreeSelect/V2FormTreeSelect';
import { searchDynamicTreeOptions } from '@/common/api/dynamicForm';

/** 类型 21；值格式沿用资源动态表单的 { dataOrigin, optionList: [{ selectedId, name }] }。 */
const Component: FC<{
  propertyItem: any;
  form: any;
  required?: boolean;
  disabled?: boolean;
}> = ({ propertyItem, form, required, disabled }) => {
  const restriction = JSON.parse(propertyItem.restriction || '{}');
  const { dataOrigin, multiple } = restriction;
  const label = propertyItem.anotherName || propertyItem.name || '';
  const placeholder = restriction.placeholder || `请选择${label}`;
  const value: any = Form.useWatch(propertyItem.identification, form);
  const selectedIds = JSON.stringify((value?.optionList || []).map(item => item.selectedId));
  const [search, setSearch] = useState('');
  const [treeData, setTreeData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!dataOrigin) {
      setTreeData([]);
      setLoading(false);
      return;
    }
    let active = true;
    const timer = setTimeout(() => {
      setLoading(true);
      searchDynamicTreeOptions({ dataOrigin, name: search.trim() || null, valueList: JSON.parse(selectedIds) }).then((res) => {
        if (active) setTreeData(Array.isArray(res) ? res : []);
      }, () => {
        if (active) setTreeData([]);
      }).finally(() => {
        if (active) setLoading(false);
      });
    }, search ? 400 : 0);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [dataOrigin, search, selectedIds]);

  const methods = useMethods({
    onSearch(name: string) {
      setSearch(name);
    },
    validateValue(_rule: any, value: any) {
      return required && !value?.optionList?.length
        ? Promise.reject(new Error(placeholder))
        : Promise.resolve();
    },
  });

  return <V2FormTreeSelect
    label={label}
    name={propertyItem.identification}
    placeholder={placeholder}
    required={required}
    disabled={disabled}
    rules={[{ validator: methods.validateValue }]}
    treeData={treeData}
    formItemConfig={{
      required,
      getValueFromEvent: (value: any) => ({
        dataOrigin,
        optionList: (value ? (Array.isArray(value) ? value : [value]) : []).map(item => ({ selectedId: item.value, name: item.label })),
      }),
      getValueProps: (value: any) => {
        const options = (value?.optionList || []).map(item => ({ value: String(item.selectedId), label: item.name }));
        return { value: multiple ? options : options[0] };
      },
    }}
    config={{
      multiple: !!multiple,
      labelInValue: true,
      showSearch: true,
      filterTreeNode: false,
      fieldNames: { label: 'name', value: 'value', children: 'children' },
      onSearch: methods.onSearch,
      notFoundContent: loading ? <Spin size='small' /> : undefined,
    }}
  />;
};

export default Component;
